module.exports = __webpack_public_path__ + "d41582f56a856c0bf8a48a94d1dc0852.pdf";